import React from "react";
import { FaPlug, FaLightbulb } from "react-icons/fa";
import styles from "./Monitor.module.css";

const isActiveValue = (value) => {
  return (
    value === true ||
    value === 1 ||
    value === "1" ||
    value === "true" ||
    value === "TRUE" ||
    value === "on" ||
    value === "ON"
  );
};

const getCustomName = (customNames, index) => {
  if (!customNames) return "";

  const name = customNames[index] ?? customNames[String(index)];

  if (name === undefined || name === null || String(name).trim() === "") {
    return "";
  }

  return String(name).trim();
};

const DigitalInputMonitorCard = ({
  type,
  index,
  label,
  icon,
  data,
  customNames = {},
}) => {
  if (!data) return null;

  const { status, triggered } = data;

  const isOn = isActiveValue(status);
  const isTriggered = isActiveValue(triggered);

  const customName = getCustomName(customNames, index);
  const displayName = customName || label;
  const displayTitle = customName ? `${customName} - ${label}` : label;

  return (
    <div className={`${styles.sensorCard} ${styles.monitorOnlyCard}`}>
      <div className={styles.cardHeader}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            minWidth: 0,
          }}
        >
          {icon}

          <span
            className={`
        ${styles.cardDisplayName}
        ${!customName ? styles.cardDisplayNameDefault : ""}
    `}
            title={displayTitle}
          >
            {displayName}
          </span>
        </div>
      </div>

      <div className={styles.centerStatus}>
        <div
          style={{
            position: "relative",
            width: "50px",
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FaPlug
            className={`
                            ${styles.powerIcon}
                            ${isOn ? styles.inputActive : styles.inputInactiveBase}
                        `}
            style={{
              transform: "rotate(180deg)",
            }}
            title={isOn ? "ورودی روشن" : "ورودی خاموش"}
          />

          {!isOn && <div className={styles.diagonalLine}></div>}
        </div>

        <div className={styles.statusText}>{isOn ? "روشن" : "خاموش"}</div>
      </div>
      <FaLightbulb
        className={`
        ${styles.cardTrigCorner}
        ${isTriggered ? styles.cardTrigCornerOn : styles.cardTrigCornerOff}
    `}
        title={isTriggered ? "Trig فعال" : "Trig غیرفعال"}
      />
    </div>
  );
};

export default DigitalInputMonitorCard;
